
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal, notification } from 'antd';
import axiosInstance from '../../../../../Services/axiosCommon';
import More from '../../../../../Components/Icons/More';
import { Link } from 'react-router-dom';
// import EditCondition from './EditCondition';
import { useState } from 'react';
// import ViewCondition from './ViewCondition';
import { GetAccess } from '../../../../../Components/Utils/roles';
import EditSubItemsManpower from './EditSubItemManpower';
import ViewManpowerItems from './ViewManpower';
// import EditSubItemsBOQ from './EditSubItemsBOQ';
// import ViewBOQItems from './ViewBOQItems';


const ViewMore = ({ data, getData,id,estimationId,Role }) => {
  const { confirm } = Modal;
  const [open, setOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);


  const [api, contextHolder] = notification.useNotification();
  const handleDelete = async(id,removevalue) =>{
    confirm({
        title: `Do you Want to delete ${removevalue}?`,
        centered:true,
        width:"25%",
        icon: <ExclamationCircleFilled />,
        content: `The ${removevalue} will be removed from the Manpower`,
        okText: 'Yes',
        okButtonProps: {
          style: { backgroundColor: '#048178', borderColor: '#048178', color: '#FFFFFF' },
      },
        cancelText: 'No',
        onOk() {
          axiosInstance.delete(`/manpower/delete/${id}`).then((res) => {
            if(res.status === 201||res.status === 200) {
                getData();
                api.success({
                  message: `Manpower Item has deleted successfully`,
                  description:res?.data?.msg||' ',
                  placement: 'bottomRight',
                });
            } else{
                api.error({
                    message: `Manpower Item has delete failed`,
                    description:res?.data?.msg||'Network error',
                    placement: 'bottomRight',
                  });
            }
            })
            .catch((error) => {
                api.error({
                    message: `Manpower Item has delete failed`,
                    description:error?.response?.data?.msg||'Sever error (or) Network error',
                    placement: 'bottomRight',
                  });
            });
        },
        onCancel() {
        },
      });
}




  return (
    <>
    {contextHolder}
      <div className='text-[#344767]  relative dropdown inline-block z-1 group'>
        <div className=' cursor-pointer underline-offset-8 text-xs mx-auto font-semibold flex items-center'>
          <span className=' w-7 h-7 bg-gray-50 flex flex-col items-center justify-center rounded-full'>
            <More/>
          </span>
        </div>
        <ul className='dropdown-menuOne   text-[#344767] text-left  rounded-lg absolute -left-[80px] -top-3 overflow-hidden hidden  z-50 shadow-lg group-hover:block'>
        {/* <li className=' w-[100px] bg-black block m-0'>
            <span
              className='bg-white hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium'
              // onClick={() => setOpen(true)}
            >
              <Link className=' text-black hover:text-black' to={`/item/teamandcondition/view/${id}`} state={{ data: data }} >View</Link>
            </span>
          </li> */}
           <li className='w-[100px] bg-black block m-0'>
            <span
              className='bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium'
              onClick={() => setViewOpen(true)}
            >
              View
            </span>
          </li>
          {GetAccess(true) && <li className=' w-[100px] bg-black block m-0'>
            <span
              className='bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium'
              onClick={() => setOpen(true)}
            >
              Edit
            </span>
          </li>}
          {
            GetAccess(true) &&
            <li className=' w-[100px] bg-black block m-0'>
            <span
              className='bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium'
              onClick={
                () => {
                  handleDelete(data.id,data?.role);
                }
              }
            >
              Delete
            </span>
          </li>
          }
        </ul>
      </div>
       <EditSubItemsManpower
            data={data}
open={open} onCancel={() => { setOpen(false) }} getData={getData}
estimationId={estimationId}
id={id}
Role={Role}

      />
      <Modal
        open={viewOpen}
        onCancel={()=>setViewOpen(false)}
        title={"View Manpower Item"}
        width="50%"
        centered
           className="my-modal"
     
        footer={[]}
      >
        <ViewManpowerItems data={data} open={viewOpen} onCancel={() => setViewOpen(false)} />
      </Modal>
    </>
  );
};

export default ViewMore;

